import React from 'react';
import { ICustomSpinner } from './CustomSpinnerTypes';
import { customSpinnerStyles } from './CustomSpinner.styles';
import { useMediaQuery, useTheme } from '@material-ui/core';

const CustomSpinner: React.FC<ICustomSpinner> = () => {
	const classes = customSpinnerStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<div className={classes.containerLoader}>
			<div className={isMobile ? `${classes.loader}` : `${classes.loader} ${classes.loaderDesktop}`} />
		</div>
	);
};

export default CustomSpinner;
